var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBritish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.847,
    height: 37.848,
    viewBox: "0 0 37.847 37.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f0f0f0;}.b{fill:#0b34ef;}.c{fill:#fa0b54;}.d{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 37.847,
    height: 37.848,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 -3.152)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -9, 3.15)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 9.923,
    cy: 9.924,
    rx: 9.923,
    ry: 9.924,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.214 9)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 9.51,
    cy: 9.424,
    rx: 9.51,
    ry: 9.424,
    transform: "translate(0.214 1.152)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.26 0.344)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.54,100.142a9.953,9.953,0,0,0-1.721,3.476h5.2Z",
    transform: "translate(-8.819 -96.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M375.2,103.619a9.954,9.954,0,0,0-1.721-3.476l-3.476,3.476Z",
    transform: "translate(-355.89 -96.614)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.819,322.784a9.955,9.955,0,0,0,1.721,3.476l3.476-3.476Z",
    transform: "translate(-8.819 -310.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M326.258,10.54a9.954,9.954,0,0,0-3.476-1.721v5.2Z",
    transform: "translate(-310.515 -8.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M100.142,373.481a9.955,9.955,0,0,0,3.476,1.721v-5.2Z",
    transform: "translate(-96.574 -356.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M103.618,8.819a9.954,9.954,0,0,0-3.476,1.721l3.476,3.476Z",
    transform: "translate(-96.574 -8.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M322.783,375.2a9.954,9.954,0,0,0,3.476-1.721l-3.476-3.476Z",
    transform: "translate(-310.516 -356.063)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M370.005,322.784l3.476,3.476a9.954,9.954,0,0,0,1.721-3.476Z",
    transform: "translate(-355.89 -310.65)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.084 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M19.915,8.621H11.3V.084A10.179,10.179,0,0,0,8.7.084V8.621H.085a9.919,9.919,0,0,0,0,2.586H8.7v8.537a10.179,10.179,0,0,0,2.609,0V11.207h8.611a9.919,9.919,0,0,0,0-2.586Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M322.783,322.783h0l4.458,4.458q.308-.307.587-.641l-3.817-3.817h-1.229Z",
    transform: "translate(-310.167 -310.339)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M79.438,322.784h0l-4.458,4.458q.307.308.641.587l3.817-3.817Z",
    transform: "translate(-72.054 -310.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M64.978,79.438h0L60.52,74.98q-.308.307-.587.641l3.817,3.817h1.229Z",
    transform: "translate(-57.594 -72.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M322.783,64.979h0l4.458-4.458q-.307-.308-.641-.587l-3.817,3.817Z",
    transform: "translate(-310.167 -57.595)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBritish);
export default __webpack_public_path__ + "static/media/british.34fb7ebfe124630c7c27a500c46d408a.svg";
export { ForwardRef as ReactComponent };